<EXP__glxy-wrap>
  <mat-form-field class="item-selector">
    <mat-label>{{ 'ITEM_SEARCH_SELECT_FILTER.SEARCH' | translate }}</mat-label>
    <ng-container *ngIf="templateState$ | async as state; else loadingChips">
      <div class="dropdown-container">
        <mat-chip-grid #chipList>
          <mat-chip-row
            *ngFor="let requiredApp of state.selectedItems"
            (removed)="removeItem(requiredApp, state.selectedItems)"
          >
            {{ requiredApp.name }}
            <button matChipRemove>
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
          <input
            #chipInput
            data-cy="item-search-select-input"
            [formControl]="searchCtrl"
            [matChipInputFor]="chipList"
            [matAutocomplete]="autocomplete"
          />
        </mat-chip-grid>
        <mat-icon class="selector-arrow cursor-pointer" matSuffix (click)="chipInput.focus()">arrow_drop_down</mat-icon>
        <mat-autocomplete
          #autocomplete="matAutocomplete"
          (optionSelected)="addItem($event, state.selectedItems)"
          [displayWith]="displayFn"
        >
          <mat-option *ngFor="let appSummary of state.availableItems" [value]="appSummary">
            <div class="item-option">
              {{ appSummary.name }}
            </div>
          </mat-option>
          <glxy-infinite-scroll-trigger
            [visiblilityMargin]="60"
            (isVisible)="loadMore()"
          ></glxy-infinite-scroll-trigger>
        </mat-autocomplete>
      </div>
    </ng-container>

    <ng-template #loadingChips>
      <mat-chip-grid #chipList disabled>
        <mat-chip-row class="loading-chip stencil-shimmer"></mat-chip-row>
        <input #chipInput [matChipInputFor]="chipList" />
        <mat-icon class="selector-arrow" matSuffix>arrow_drop_down</mat-icon>
      </mat-chip-grid>
    </ng-template>
  </mat-form-field>
</EXP__glxy-wrap>
